// extracted by mini-css-extract-plugin
export default {"reviewsGrid":"Reviews_reviewsGrid__Fl8nF","h2":"Reviews_h2__5VrsE"};